import React from 'react';
import { motion } from 'framer-motion';
import { SECTIONS } from '../folio/sections';

// Vertical tab dividers on right edge of the book.
export default function TabRail({ activeId, onSelect }) {
    return (
        <div
            data-testid="folio-tab-rail"
            className="absolute top-6 bottom-6 right-0 translate-x-full pl-2 flex flex-col gap-3 z-40"
        >
            {SECTIONS.map((s, i) => {
                const active = s.id === activeId;
                return (
                    <motion.button
                        key={s.id}
                        data-testid={`tab-${s.id}`}
                        onClick={() => onSelect(s.id)}
                        className={`tab-divider group relative flex items-center gap-3 pl-4 pr-6 py-4 rounded-r-sm border-y border-r border-[color:var(--moss-deep)] text-left ${active ? 'active' : ''}`}
                        style={{
                            backgroundColor: active ? s.color : 'var(--parchment)',
                            color: 'var(--moss-dark)',
                            minWidth: '160px',
                        }}
                        initial={{ opacity: 0, x: 40 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.2 + i * 0.06, duration: 0.6, ease: [0.83, 0, 0.17, 1] }}
                        whileHover={{ x: active ? 14 : 6 }}
                    >
                        <span
                            className="tab-index"
                            style={{ color: active ? 'var(--moss-dark)' : 'var(--moss-deep)' }}
                        >
                            0{i + 1}
                        </span>
                        <span className="font-medium tracking-tight text-[15px] whitespace-nowrap">
                            {s.label}
                        </span>
                        <span
                            className="ml-auto h-2 w-2 rounded-full border border-[color:var(--moss-deep)]"
                            style={{ background: active ? 'var(--moss-deep)' : 'transparent' }}
                        />
                    </motion.button>
                );
            })}
        </div>
    );
}

// Mobile stacked navigation → horizontal scroll-snap bar
export function TabRailMobile({ activeId, onSelect }) {
    return (
        <div
            data-testid="folio-tab-rail-mobile"
            className="lg:hidden flex gap-2 px-4 py-3 bg-[color:var(--moss-deep)] sticky top-0 z-40 border-b border-[color:var(--moss-dark)] overflow-x-auto snap-x snap-mandatory scrollbar-none"
            style={{ WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none' }}
        >
            {SECTIONS.map((s, i) => {
                const active = s.id === activeId;
                return (
                    <button
                        key={s.id}
                        data-testid={`tab-mobile-${s.id}`}
                        onClick={() => onSelect(s.id)}
                        className="snap-start shrink-0 px-3 py-2 rounded-sm text-xs mono border transition-all whitespace-nowrap"
                        style={{
                            background: active ? s.color : 'transparent',
                            color: active ? 'var(--moss-dark)' : 'var(--parchment)',
                            borderColor: active ? s.color : 'rgba(241,234,209,0.25)',
                        }}
                    >
                        <span className="opacity-60 mr-2">0{i + 1}</span>
                        {s.label}
                    </button>
                );
            })}
        </div>
    );
}
